module.exports = __webpack_public_path__ + "img/jazzy-thumbnail-fallback-groove.6826a6d.jpg";